import React from 'react'
import { connect } from 'react-redux'
import { LoadingIndicator, WithPermissions } from 'react-admin'
import classNames from 'classnames'
import compose from 'recompose/compose'
import { toggleSidebar as toggleSidebarAction } from 'ra-core'

import MuiAppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import MenuIcon from '@material-ui/icons/Menu'
import withWidth from '@material-ui/core/withWidth'
import { Link } from 'react-router-dom'
import { push } from 'react-router-redux'
import UserMenu from './UserMenu'
import Hidden from '@material-ui/core/Hidden'
import { envPreffix } from '../../utils'

const styles = theme => ({
    responsiveAppbar : {
        position : 'initial',
        [theme.breakpoints.down('xs')]: {
            position : 'fixed'
        },
    },
    publicAppBar : {
        backgroundColor : '#282c34',
        boxShadow: 'none'
    },
    privateAppBar : {
        boxShadow: 'none',
        backgroundColor : '#3C5171'
    },
    toolbar: {
        paddingRight: 24,
    },
    menuButton: {
        marginLeft: '0.5em',
        marginRight: '0.5em',
    },
    menuButtonIconClosed: {
        transition: theme.transitions.create(['transform'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        transform: 'rotate(0deg)',
    },
    menuButtonIconOpen: {
        transition: theme.transitions.create(['transform'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        transform: 'rotate(180deg)',
    },
    subtitle: {
        flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    title : {
        borderLeft: '1px solid #fff',
        marginLeft: 12,
        padding: 12,
        flex: 1,
        textDecoration : 'none',
        [theme.breakpoints.down('xs')]: {
            borderLeft : 'none'
        },
    },
    logo : {
        height: 48,
        margin: '5px 0',
    },
    loginAccess : {
        backgroundColor: '#286B8C',
        padding: 20,
        cursor: 'pointer',
        transition : 'background-color 250ms',
        textDecoration : 'none',
        '&:hover' : {
            backgroundColor: '#21536C',
        }
    },
    loader : {
        marginRight : 10,
    }
})

const AppBar = (props) => {
    const {
        children,
        classes,
        className,
        logout,
        open,
        title,
        toggleSidebar,
        userMenu,
        width,
        push,
        ...rest
    } = props
    const envTitle = envPreffix()

    return (
        <WithPermissions>
        {({ permissions }) => {
            if(permissions == null){ return null }
            const role = permissions.role
            const appBarClass = role === 'guest' ? classes.publicAppBar : classes.privateAppBar
        return (
        <MuiAppBar
            className={classNames(className, appBarClass, classes.responsiveAppbar)}
            color="secondary"
            position="static"
            {...rest}
        >
            <Toolbar
                disableGutters
                variant={width === 'xs' ? 'regular' : 'dense'}
                className={classes.toolbar}
            >
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={toggleSidebar}
                    className={classNames(classes.menuButton)}
                >
                    <MenuIcon
                        classes={{
                            root: open
                                ? classes.menuButtonIconOpen
                                : classes.menuButtonIconClosed,
                        }}
                    />
                </IconButton>

                <a className='HeaderLogo' href='https://www.coordinador.cl/' target="_blank" rel="noopener noreferrer">
                    <img className={classes.logo} src="/logo.svg" alt="logo" />
                </a>
                <Typography 
                    className={classes.title} 
                    variant="title" 
                    color="inherit" 
                    noWrap
                    component={Link} 
                    to={{pathname: "/"}}
                >
                    <Hidden xsDown>
                        Activos de Transmisión {envTitle ? <strong style={{color: 'red'}}>{envTitle}</strong> : ''}
                    </Hidden>
                </Typography>

                <LoadingIndicator className={classes.loader} />
                {role === 'guest' ?
                <span className={classes.loginAccess} onClick={() => push('/login')}  >Ingreso Coordinados</span>
                : <UserMenu logout={logout} />
                }
                
            </Toolbar>
        </MuiAppBar>)
        }}
        </WithPermissions>
    )
}

const enhance = compose(
    connect(
        state => ({ locale: state.i18n.locale }),
        { toggleSidebar: toggleSidebarAction, push }
    ),
    withStyles(styles),
    withWidth()
)

export default enhance(AppBar)
